<template>
    <div class="menu-container">
        <div id="menu-head" class="menu-head">
            <CategoryList :categlist="categlist" :shops="shops" @scrollto="tryScrollTo" @back="$emit('back')" :shop="shop"/>
            <CartWidget :cart="cart" @order="$emit('order')" :shop="shop"/>
        </div>
        <div id="menu-wrapper" class="menu-wrapper">
            <MenuCategory :MenuCat="hitcateg" :shop="shop" />
            <MenuCategory v-for="item in Object.entries(menulist)" :key="item[0]" :MenuCat="item" :shop="shop"/>
        </div>
    </div>
</template>

<script>
import CategoryList from './CategoryList'
import MenuCategory from './MenuCategory'
import CartWidget from './CartWidget'

export default {
    props:['menulist', 'shops', 'shop', 'merchant'],
    data(){
        return {
            offset: 0
        }
    },
    methods:{
        moveScreenTo(id){
            let el = document.getElementById(id)
            let offset = this.getOffsetSum(el).top - document.getElementById('menu-head').offsetHeight - this.computed_offset 
            window.scrollTo({
                top: offset,
                behavior: "smooth"
            })
        },
        tryScrollTo(id){
            this.moveScreenTo(id)
        },
        getOffsetSum(elem) {
            var top=0, left=0
            while(elem) {
                top = top + parseFloat(elem.offsetTop)
                left = left + parseFloat(elem.offsetLeft)
                elem = elem.offsetParent       
            }
            return {top: Math.round(top), left: Math.round(left)}
        },
        handleScroll(){           
            if (this.offset == 0) {
                this.offset = this.getOffsetSum(document.getElementById('menu-head')).top - +this.computed_offset
            }
            let header = document.getElementById('menu-head')
            if (window.scrollY > this.offset) {
                if (!header.classList.contains('fixed')) {
                    this.offset = this.getOffsetSum(document.getElementById('menu-head')).top - +this.computed_offset
                    header.classList.add('fixed')
                    header.style.top = this.computed_offset+'px'
                }
            } else if (header.classList.contains('fixed')) {
                header.classList.remove('fixed')
                header.removeAttribute('style')
            }
        },
        handleResize(){
            document.getElementById('menu-wrapper').style.marginTop = document.getElementById('menu-head').offsetHeight+'px'
        }
    },
    computed:{
        computed_offset(){
            return window.innerWidth < this.merchant.head_mobile_break ? this.merchant.head_mobile_offset : this.merchant.head_offset
        },
        flatlist(){
            let res = []
            for (let line of Object.entries(this.menulist)) {
                Array.prototype.push.apply(res, line[1]) 
            }
            return res
        },
        hitcateg(){
            return [this.shop.hitcateg_name, this.flatlist.filter(el => (el.ishit == 1))]
        },
        categlist: function () {
            let res = []
            for (let key of Object.entries(this.menulist)) {
                res.push(key[0])
            }
            return res
        },
        cart: function () {
            let res = []
            for (let line of Object.entries(this.menulist)) {
                Array.prototype.push.apply(res, line[1].filter(item => item.qty > 0)) 
            }
            return res
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('resize', this.handleResize)
        this.$nextTick(()=>{
            this.handleResize()
        })
    },
    updated(){
        this.$nextTick( function(){
            this.handleResize()
        })
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    components:{
        CategoryList,
        MenuCategory,
        CartWidget
    }
}
</script>